import { default_client } from '../../../services';

export default class ClientDetailState {
  current_client = default_client();

  editable_client = default_client();
}
